(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rijoux-wordmark"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rijoux-wordmark')) {
  customElements.define('rijoux-wordmark', class extends HTMLElement {
    connectedCallback() {
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.link = this.closest('a');
      this.play = this.play.bind(this);
      this.stop = this.stop.bind(this);
      this.onVisibility = () => {
        if (document.hidden) this.stop();
      };
      this.link?.addEventListener('pointerenter', this.play);
      this.link?.addEventListener('focusin', this.play);
      this.motion.addEventListener('change', this.stop);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.play();
        }
      }, { threshold: 0.5 });
      this.observer.observe(this);
    }

    play() {
      if (this.motion.matches || document.hidden || this.running) return;
      this.running = true;
      const sequence = ['oval', 'emerald', 'pear', 'cushion', 'round'];
      this.timers = sequence.map((shape, index) => window.setTimeout(() => {
        this.dataset.shape = shape;
      }, 420 + index * 760));
      this.timers.push(window.setTimeout(() => {
        this.running = false;
      }, 4100));
    }

    stop() {
      this.timers?.forEach(timer => window.clearTimeout(timer));
      this.timers = [];
      this.running = false;
      this.dataset.shape = 'round';
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      this.link?.removeEventListener('pointerenter', this.play);
      this.link?.removeEventListener('focusin', this.play);
      this.motion?.removeEventListener('change', this.stop);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
